import { z } from "zod";
export const pluginConnectionHealthStateSchema = z.enum([
    "healthy", "permission_missing", "grant_rejected", "temporary_error", "untested", "stale",
]);
export const pluginConnectionHealthSchema = z.object({
    connectionId: z.string(),
    adapterSlug: z.string(),
    state: pluginConnectionHealthStateSchema,
    operation: z.string().nullable(),
    checkedAt: z.number().nullable(),
    lastSuccessAt: z.number().nullable(),
    errorCode: z.string().nullable(),
}).strict();
export const requestPluginConnectionCheckSchema = z.object({
    connectionId: z.string().trim().min(1).max(256),
}).strict();
export const requestPluginConnectionCheckResponseSchema = z.object({
    connectionId: z.string(),
    status: z.enum(["queued", "in_progress"]),
    requestedAt: z.number(),
}).strict();
/** Fixed probe support shared by dispatch and the explicit recheck surface. */
export function pluginHealthCredentialKind(target) {
    if (target.source_kind === "connector-integration") {
        if (["google-drive", "google-sheets", "google-calendar", "google-gmail"].includes(target.plugin_slug))
            return "connector";
        return target.plugin_slug === "xero" && target.user_context_id === null ? "connector" : null;
    }
    if (target.source_kind !== "legacy-plugin-secret")
        return null;
    if (["google-drive", "google-sheets", "google-docs", "google-slides", "google-calendar", "google-gmail"].includes(target.plugin_slug)
        && ["GOOGLE_WORKSPACE_CLI_CREDENTIALS_JSON", "GOOGLE_WORKSPACE_CLI_TOKEN"].includes(target.secret_name ?? ""))
        return "secret";
    return target.plugin_slug === "slack" && target.secret_name === "SLACK_MCP_OAUTH_TOKEN" ? "secret" : null;
}
